import { EXPORT_DOCUMENT_TITLE_KEYS } from './exportExcelNaming';
import { uiT } from './uiTranslate';

/** Visible leading order for qlty002/004/006: checkbox → edit icon → ID. */
export const ERROR_RECORD_LEADING_COLUMN_FIELDS = Object.freeze(['rowSelection', 'editor', 'id']);

/**
 * Saved user/standard masks may still store checkbox → ID → editor.
 * Reorder only those three fields when present; leave remaining columns intact.
 */
export function pinErrorRecordLeadingColumns(attributes) {
  if (!Array.isArray(attributes) || attributes.length === 0) return attributes;
  const leadingSet = new Set(ERROR_RECORD_LEADING_COLUMN_FIELDS);
  const byField = new Map();
  const rest = [];
  for (const node of attributes) {
    const field = node && typeof node === 'object' ? node.field : null;
    if (typeof field === 'string' && leadingSet.has(field) && !byField.has(field)) {
      byField.set(field, node);
    } else {
      rest.push(node);
    }
  }
  const leading = ERROR_RECORD_LEADING_COLUMN_FIELDS
    .map((field) => byField.get(field))
    .filter(Boolean);
  if (leading.length === 0) return attributes;
  return [...leading, ...rest];
}

export const ERROR_RECORD_LIST_MASKS = Object.freeze({
  int: Object.freeze({
    pageListKey: 'ZoznamInt',
    errorRecordType: 'Interná chyba', // RAW API type token
    detailPage: 'InternaChyba',
    detailMask: 'qlty003',
    addTabKey: 'Otk.NewInternalErrorUpper',
    editTabKey: 'Otk.EditInternalErrorUpper',
    get addTabName() { return uiT('Otk.NewInternalErrorUpper'); },
    get editTabName() { return uiT('Otk.EditInternalErrorUpper'); },
    notificationPage: 'InternaChyba',
    exportTitleKey: EXPORT_DOCUMENT_TITLE_KEYS.ERROR_RECORDS_INT,
  }),
  ext: Object.freeze({
    pageListKey: 'ZoznamExt',
    errorRecordType: 'Externá chyba', // RAW API type token
    detailPage: 'ExternaChyba',
    detailMask: 'qlty005',
    addTabKey: 'Otk.NewExternalErrorUpper',
    editTabKey: 'Otk.EditExternalErrorUpper',
    get addTabName() { return uiT('Otk.NewExternalErrorUpper'); },
    get editTabName() { return uiT('Otk.EditExternalErrorUpper'); },
    notificationPage: 'ExternaChyba',
    exportTitleKey: EXPORT_DOCUMENT_TITLE_KEYS.ERROR_RECORDS_EXT,
  }),
  rek: Object.freeze({
    pageListKey: 'ZoznamRek',
    errorRecordType: 'Reklamácia', // RAW API type token
    detailPage: 'Reklamacia',
    detailMask: 'qlty007',
    addTabKey: 'Otk.NewComplaintUpper',
    editTabKey: 'Otk.EditComplaintUpper2',
    get addTabName() { return uiT('Otk.NewComplaintUpper'); },
    get editTabName() { return uiT('Otk.EditComplaintUpper2'); },
    notificationPage: 'Reklamacia',
    exportTitleKey: EXPORT_DOCUMENT_TITLE_KEYS.ERROR_RECORDS_REK,
  }),
});
